module.exports = __webpack_public_path__ + "img/1_ileum.17c32a3c.png";